import { AdminActionsPanel } from "@/components/organisms";

export const AdminActions = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <AdminActionsPanel />
    </div>
  );
};
